<app-header [transparent]="transparent"></app-header>
<div class="gallery">
    <div class="text-center bg_1 bg_img">
        <ng-container *ngFor="let heading of head">
            <div class="top_padding4 inline_padding1" *ngIf="heading.page === currentPage">
                <div>
                    <span class="text_style_5">Gallery</span>
                </div>
                <div class="p-top-16">
                    <span [innerHTML]="heading.page_sub_heading"></span>
                </div>
            </div>
        </ng-container>
        <div class="p-top-60 inline_padding1 bg_2">

        </div>
    </div>
    <div class="gallery_album p-b-80 bg_2">
        <div class="dis-flex-1">
            <div class="gallery_album_leftbox p-x-50 m-t-100-neg bg_1">
            </div>
            <div class="gallery_album_item">
                <ng-container *ngFor="let data of galleryArr; let i = index">
                    <!-- these will show until the desktop screen -->

                    <!-- Image at index 0 (Left side) -->
                    <div class="width-10-per gallery_album_item_body  m-t-100-neg m-l-80-neg width-20-per z_index_1 text-center"
                        *ngIf="i === 0">
                        <div class="gallery_album_item_body_box" *ngIf="i === 0">
                            <img [src]="getGalleryImageUrl(data)" alt="gallery_image"
                                class="gallery_album_item_body_box_img" />
                        </div>
                    </div>

                    <!--Image at index 1 (Left side) -->
                    <div class="width-20-per gallery_album_item_body  p-top-20" *ngIf="i === 1">
                        <div class="dis-block-2 ">
                            <div class=" p-top-20  gallery_album_item_body_box">
                                <img [src]="getGalleryImageUrl(data)" alt="gallery_image"
                                    class="gallery_album_item_body_box_img" />
                            </div>
                            <div *ngIf="i === 1" (click)="leftClick()" class="dis-flex-2 p-top-24">
                                <div class=" bg_2 height-40 width-40  dis-flex-2 gallery_album_item_body_btn">
                                    <svg width="9" height="16" viewBox="0 0 9 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.70415 16C7.55932 16.0009 7.41575 15.9719 7.28167 15.9148C7.14759 15.8577 7.02564 15.7735 6.92281 15.6671L0.320008 8.78071C0.115045 8.56567 0 8.27477 0 7.97156C0 7.66834 0.115045 7.37745 0.320008 7.1624L6.92281 0.275982C7.13334 0.0879519 7.40413 -0.0103014 7.6811 0.000855961C7.95806 0.0120133 8.22078 0.131759 8.41677 0.336165C8.61276 0.54057 8.72757 0.81458 8.73827 1.10344C8.74897 1.3923 8.65476 1.67473 8.47447 1.89429L2.653 7.96582L8.47447 14.0374C8.629 14.1972 8.73462 14.4012 8.77796 14.6237C8.8213 14.8461 8.80043 15.077 8.71797 15.2871C8.63552 15.4971 8.49519 15.677 8.31473 15.8039C8.13427 15.9308 7.92179 15.999 7.70415 16Z"
                                            fill="#0032A0" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Image at index 2 (Center) -->
                    <div class="width-40-per gallery_album_item_body text-center p-top-40 p-b-80"
                        (click)="goToGallaryDetail(data._id)" *ngIf="i === 2">
                        <div class="dis-block-2 ">
                            <div class="p-top-40  gallery_album_item_body_box">
                                <div class="width-70-per">
                                    <img [src]="getGalleryImageUrl(data)" alt="gallery_image"
                                        class="gallery_album_item_body_box_img" />
                                </div>
                            </div>
                            <div class="p-top-40">
                                <div class="text_black_1_res" style="margin-top: 100px;">{{data.title}}</div>
                                <div [innerHtml]="data.description"></div>
                            </div>
                            <div class="share-buttons" style="margin-top:15px;">
                                <button (click)="copyLink()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fas fa-link" style="color: #000;"></i> <!-- Copy Link -->
                                </button>
                                <button (click)="shareViaEmail()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fas fa-envelope" style="color: #EA4335;"></i> <!-- Email -->
                                </button>
                                <button (click)="shareViaSMS()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fas fa-sms" style="color: #25D366;"></i> <!-- SMS -->
                                </button>
                                <button (click)="shareViaWhatsApp()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-whatsapp" style="color: #25D366;"></i> <!-- WhatsApp -->
                                </button>
                                <button (click)="shareViaMessenger()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-facebook-messenger" style="color: #0084FF;"></i> <!-- Messenger -->
                                </button>
                                <button (click)="shareViaViber()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-viber" style="color: #59267C;"></i> <!-- Viber -->
                                </button>
                                <button (click)="shareViaFacebook()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-facebook" style="color: #4267B2;"></i> <!-- Facebook -->
                                </button>
                                <button (click)="shareViaTwitter()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-twitter" style="color: #1DA1F2;"></i> <!-- Twitter -->
                                </button>
                                <button (click)="shareViaLinkedIn()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-linkedin" style="color: #0077B5;"></i> <!-- LinkedIn -->
                                </button>
                                <button (click)="shareViaPinterest()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-pinterest" style="color: #E60023;"></i> <!-- Pinterest -->
                                </button>
                                <button (click)="shareViaReddit()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-reddit" style="color: #FF4500;"></i> <!-- Reddit -->
                                </button>
                                <button (click)="shareViaTumblr()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-tumblr" style="color: #35465C;"></i> <!-- Tumblr -->
                                </button>
                                <button (click)="shareViaTelegram()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-telegram" style="color: #0088CC;"></i> <!-- Telegram -->
                                </button>
                                <button (click)="shareViaVK()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-vk" style="color: #4B7BE5;"></i> <!-- VK -->
                                </button>
                                <button (click)="shareViaMix()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-mix" style="color: #00A3E0;"></i> <!-- Mix -->
                                </button>
                                <button (click)="shareViaXing()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-xing" style="color: #006567;"></i> <!-- Xing -->
                                </button>
                                <button (click)="shareViaLine()"
                                    style="background: transparent; border: none; cursor: pointer;">
                                    <i class="fab fa-line" style="color: #00B900;"></i> <!-- Line -->
                                </button>

                            </div>
                        </div>
                    </div>

                    <!-- Image at index 3 (right side) -->
                    <div class="width-20-per  gallery_album_item_body  p-top-20" *ngIf="i === 3">
                        <div class="dis-block-2 ">
                            <div class="p-top-20 gallery_album_item_body_box">
                                <img [src]="getGalleryImageUrl(data)" alt="gallery_image"
                                    class="gallery_album_item_body_box_img" />
                            </div>
                            <div *ngIf="i === 3" (click)="rightClick()" class="dis-flex-2 p-top-24">
                                <div class=" bg_2 height-40 width-40  dis-flex-2  gallery_album_item_body_btn">
                                    <svg width="9" height="16" viewBox="0 0 9 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M1.29585 1.90735e-05C1.44068 -0.000854492 1.58425 0.0280972 1.71833 0.0852137C1.85241 0.14233 1.97436 0.22649 2.07719 0.332864L8.67999 7.21929C8.88496 7.43433 9 7.72523 9 8.02844C9 8.33166 8.88496 8.62255 8.67999 8.8376L2.07719 15.724C1.86666 15.912 1.59587 16.0103 1.3189 15.9991C1.04194 15.988 0.779219 15.8682 0.583231 15.6638C0.387244 15.4594 0.272429 15.1854 0.261731 14.8966C0.251033 14.6077 0.345241 14.3253 0.525526 14.1057L6.347 8.03418L0.525526 1.96265C0.370996 1.8028 0.265384 1.59875 0.222041 1.37631C0.178699 1.15386 0.199574 0.923006 0.282028 0.712933C0.364481 0.50286 0.504808 0.323004 0.685267 0.196107C0.865726 0.0692101 1.07821 0.00097084 1.29585 1.90735e-05Z"
                                            fill="#0032A0" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Image at index 4 (Right side) -->
                    <div class="width-10-per  gallery_album_item_body m-t-100-neg m-r-80-neg width-20-per z_index_1 text-center"
                        *ngIf="i === 4">
                        <div class="gallery_album_item_body_box">
                            <img [src]="getGalleryImageUrl(data)" alt="gallery_image"
                                class=" gallery_album_item_body_box_img" />
                        </div>
                    </div>

                    <!-- these will show until the tab land -->

                    <!--Image at index 1 (Left side) -->
                    <div class="width-30-per gallery_album_item_body1  p-top-20" *ngIf="i === 1">
                        <div class="dis-block-2 ">
                            <div class=" p-top-20  gallery_album_item_body1_box">
                                <img [src]="getGalleryImageUrl(data)" alt="gallery_image"
                                    class="gallery_album_item_body1_box_img" />
                            </div>
                            <div *ngIf="i === 1" (click)="leftClick()" class="dis-flex-2 p-top-24">
                                <div class=" bg_2 height-40 width-40  dis-flex-2 gallery_album_item_body1_btn">
                                    <svg width="9" height="16" viewBox="0 0 9 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.70415 16C7.55932 16.0009 7.41575 15.9719 7.28167 15.9148C7.14759 15.8577 7.02564 15.7735 6.92281 15.6671L0.320008 8.78071C0.115045 8.56567 0 8.27477 0 7.97156C0 7.66834 0.115045 7.37745 0.320008 7.1624L6.92281 0.275982C7.13334 0.0879519 7.40413 -0.0103014 7.6811 0.000855961C7.95806 0.0120133 8.22078 0.131759 8.41677 0.336165C8.61276 0.54057 8.72757 0.81458 8.73827 1.10344C8.74897 1.3923 8.65476 1.67473 8.47447 1.89429L2.653 7.96582L8.47447 14.0374C8.629 14.1972 8.73462 14.4012 8.77796 14.6237C8.8213 14.8461 8.80043 15.077 8.71797 15.2871C8.63552 15.4971 8.49519 15.677 8.31473 15.8039C8.13427 15.9308 7.92179 15.999 7.70415 16Z"
                                            fill="#0032A0" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Image at index 2 (Center) -->
                    <div class="width-40-per gallery_album_item_body1 text-center p-top-40 p-b-80"
                        (click)="goToGallaryDetail(data._id)" *ngIf="i === 2">
                        <div class="dis-block-2 ">
                            <div class="p-top-40  gallery_album_item_body1_box">
                                <div class="width-70-per">
                                    <img [src]="getGalleryImageUrl(data)" alt="gallery_image"
                                        class="gallery_album_item_body_box_img" />
                                </div>
                            </div>
                            <div class="p-top-40">
                                <div class="text_black_1_res">{{data.title}}</div>
                                <div [innerHtml]="data.description"></div>
                            </div>
                        </div>
                    </div>

                    <!-- Image at index 3 (right side) -->
                    <div class="width-30-per  gallery_album_item_body1  p-top-20" *ngIf="i === 3">
                        <div class="dis-block-2 ">
                            <div class="p-top-20 gallery_album_item_body1_box">
                                <img [src]="getGalleryImageUrl(data)" alt="gallery_image"
                                    class="gallery_album_item_body1_box_img" />
                            </div>
                            <div *ngIf="i === 3" (click)="rightClick()" class="dis-flex-2 p-top-24">
                                <div class=" bg_2 height-40 width-40  dis-flex-2  gallery_album_item_body1_btn">
                                    <svg width="9" height="16" viewBox="0 0 9 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M1.29585 1.90735e-05C1.44068 -0.000854492 1.58425 0.0280972 1.71833 0.0852137C1.85241 0.14233 1.97436 0.22649 2.07719 0.332864L8.67999 7.21929C8.88496 7.43433 9 7.72523 9 8.02844C9 8.33166 8.88496 8.62255 8.67999 8.8376L2.07719 15.724C1.86666 15.912 1.59587 16.0103 1.3189 15.9991C1.04194 15.988 0.779219 15.8682 0.583231 15.6638C0.387244 15.4594 0.272429 15.1854 0.261731 14.8966C0.251033 14.6077 0.345241 14.3253 0.525526 14.1057L6.347 8.03418L0.525526 1.96265C0.370996 1.8028 0.265384 1.59875 0.222041 1.37631C0.178699 1.15386 0.199574 0.923006 0.282028 0.712933C0.364481 0.50286 0.504808 0.323004 0.685267 0.196107C0.865726 0.0692101 1.07821 0.00097084 1.29585 1.90735e-05Z"
                                            fill="#0032A0" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>


                    <!-- these will show until the phone screen -->
                    <!-- <div  class="dis-flex-2 p-top-24"> -->
                    <div class=" bg_2 height-40 width-40  dis-flex-2 gallery_album_item_body2_btn" *ngIf="i === 1"
                        (click)="leftClick()">
                        <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M7.70415 16C7.55932 16.0009 7.41575 15.9719 7.28167 15.9148C7.14759 15.8577 7.02564 15.7735 6.92281 15.6671L0.320008 8.78071C0.115045 8.56567 0 8.27477 0 7.97156C0 7.66834 0.115045 7.37745 0.320008 7.1624L6.92281 0.275982C7.13334 0.0879519 7.40413 -0.0103014 7.6811 0.000855961C7.95806 0.0120133 8.22078 0.131759 8.41677 0.336165C8.61276 0.54057 8.72757 0.81458 8.73827 1.10344C8.74897 1.3923 8.65476 1.67473 8.47447 1.89429L2.653 7.96582L8.47447 14.0374C8.629 14.1972 8.73462 14.4012 8.77796 14.6237C8.8213 14.8461 8.80043 15.077 8.71797 15.2871C8.63552 15.4971 8.49519 15.677 8.31473 15.8039C8.13427 15.9308 7.92179 15.999 7.70415 16Z"
                                fill="#0032A0" />
                        </svg>
                    </div>

                    <div class="width-80-per gallery_album_item_body2 text-center p-top-40 p-b-80"
                        (click)="goToGallaryDetail(data._id)" *ngIf="i === 2">
                        <div class="dis-block-2 ">
                            <div class="p-top-40  gallery_album_item_body2_box">
                                <div class="width-70-per">
                                    <img [src]="getGalleryImageUrl(data)" alt="gallery_image"
                                        class="gallery_album_item_body2_box_img" />
                                </div>
                            </div>
                            <div class="p-top-40 p-b-80">
                                <div class="text_black_1_res">{{data.title}}</div>
                                <div [innerHtml]="data.description"></div>
                            </div>
                        </div>
                    </div>
                    <!-- <div *ngIf="i === 3" (click)="rightClick()" class="dis-flex-2 p-top-24"> -->
                    <div class=" bg_2 height-40 width-40  dis-flex-2  gallery_album_item_body2_btn" *ngIf="i === 3"
                        (click)="rightClick()">
                        <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M1.29585 1.90735e-05C1.44068 -0.000854492 1.58425 0.0280972 1.71833 0.0852137C1.85241 0.14233 1.97436 0.22649 2.07719 0.332864L8.67999 7.21929C8.88496 7.43433 9 7.72523 9 8.02844C9 8.33166 8.88496 8.62255 8.67999 8.8376L2.07719 15.724C1.86666 15.912 1.59587 16.0103 1.3189 15.9991C1.04194 15.988 0.779219 15.8682 0.583231 15.6638C0.387244 15.4594 0.272429 15.1854 0.261731 14.8966C0.251033 14.6077 0.345241 14.3253 0.525526 14.1057L6.347 8.03418L0.525526 1.96265C0.370996 1.8028 0.265384 1.59875 0.222041 1.37631C0.178699 1.15386 0.199574 0.923006 0.282028 0.712933C0.364481 0.50286 0.504808 0.323004 0.685267 0.196107C0.865726 0.0692101 1.07821 0.00097084 1.29585 1.90735e-05Z"
                                fill="#0032A0" />
                        </svg>
                    </div>


                </ng-container>
            </div>
            <div class="gallery_album_rightbox p-x-50 m-t-100-neg bg_1">
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>


<!-- <ng-container *ngFor="let data of galleryArr; let i = index">
                <div class="gallery_album_item m-t-100-neg m-l-80-neg width-20-per z_index_1 text-center" *ngIf="i === 0">
                    <div class="gallery_album_item_box p-top-20">
                        <img class="gallery_album_item_box_img border-radius-10" [src]="imageBaseUrl+data.poster" alt="gallery_image" />
                    </div>                
                </div>
                <div class="gallery_album_item m-t-100-neg m-r-80-neg width-20-per z_index_1 text-center" *ngIf="i === 4">
                    <div class="gallery_album_item_box p-top-20">
                        <img class="gallery_album_item_box_img border-radius-10" [src]="imageBaseUrl+data.poster" alt="gallery_image" />
                    </div>                
                </div>
                <div class="gallery_album_item width-20-per text-center" *ngIf="i === 1 || i === 3">
                    <div class="gallery_album_item_box p-top-20">
                        <img class="gallery_album_item_box_img border-radius-10" [src]="imageBaseUrl+data.poster" alt="gallery_image" />
                    </div>                                 
                    <div class="dis-flex-5 p-top-150 p-r-70" *ngIf="i === 1" (click)="leftClick()">
                        <div class="gallery_album_item_btn bg_2 height-40 width-40 border-radius-50-per dis-flex-2">
                            <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.70415 16C7.55932 16.0009 7.41575 15.9719 7.28167 15.9148C7.14759 15.8577 7.02564 15.7735 6.92281 15.6671L0.320008 8.78071C0.115045 8.56567 0 8.27477 0 7.97156C0 7.66834 0.115045 7.37745 0.320008 7.1624L6.92281 0.275982C7.13334 0.0879519 7.40413 -0.0103014 7.6811 0.000855961C7.95806 0.0120133 8.22078 0.131759 8.41677 0.336165C8.61276 0.54057 8.72757 0.81458 8.73827 1.10344C8.74897 1.3923 8.65476 1.67473 8.47447 1.89429L2.653 7.96582L8.47447 14.0374C8.629 14.1972 8.73462 14.4012 8.77796 14.6237C8.8213 14.8461 8.80043 15.077 8.71797 15.2871C8.63552 15.4971 8.49519 15.677 8.31473 15.8039C8.13427 15.9308 7.92179 15.999 7.70415 16Z" fill="#0032A0"/>
                            </svg>                                
                        </div>
                    </div>
                    <div class="dis-flex-4 p-top-150 p-l-70" *ngIf="i === 3" (click)="rightClick()">
                        <div class="gallery_album_item_btn bg_2 height-40 width-40 border-radius-50-per dis-flex-2">
                            <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.29585 1.90735e-05C1.44068 -0.000854492 1.58425 0.0280972 1.71833 0.0852137C1.85241 0.14233 1.97436 0.22649 2.07719 0.332864L8.67999 7.21929C8.88496 7.43433 9 7.72523 9 8.02844C9 8.33166 8.88496 8.62255 8.67999 8.8376L2.07719 15.724C1.86666 15.912 1.59587 16.0103 1.3189 15.9991C1.04194 15.988 0.779219 15.8682 0.583231 15.6638C0.387244 15.4594 0.272429 15.1854 0.261731 14.8966C0.251033 14.6077 0.345241 14.3253 0.525526 14.1057L6.347 8.03418L0.525526 1.96265C0.370996 1.8028 0.265384 1.59875 0.222041 1.37631C0.178699 1.15386 0.199574 0.923006 0.282028 0.712933C0.364481 0.50286 0.504808 0.323004 0.685267 0.196107C0.865726 0.0692101 1.07821 0.00097084 1.29585 1.90735e-05Z" fill="#0032A0"/>
                            </svg>                                
                        </div>
                    </div>                   
                </div>
                <div class="gallery_album_item width-40-per text-center" *ngIf="i === 2" (click)="goToGallaryDetail(data._id)">
                    <div class="gallery_album_item_box p-top-24 p-b-80">
                      <img class="gallery_album_item_box_img border-radius-10" [src]="imageBaseUrl + data.poster" alt="gallery_image" />
                    </div>
                    <div class="text_black_1_res">{{data.title}}</div>
                    <div [innerHtml]="data.description"></div>
                  </div>
                  
            </ng-container> -->